
import React, { useRef, useEffect } from 'react';
import VideoControls from './VideoControls';
import { Heart } from 'lucide-react';
import { Avatar, AvatarFallback, AvatarImage } from '@/components/ui/avatar';
import ClickPointsAnimation from '@/components/animations/ClickPointsAnimation';

interface VideoPlayerProps {
  videoUrl: string;
  videoId: string;
  onTip: (amount: number) => void;
  tipAmount: number;
  setTipAmount: (amount: number) => void;
}

const VideoPlayer: React.FC<VideoPlayerProps> = ({
  videoUrl,
  videoId,
  onTip,
  tipAmount,
  setTipAmount
}) => {
  const videoRef = useRef<HTMLVideoElement>(null);

  // Play video when component mounts
  useEffect(() => {
    if (videoRef.current) {
      videoRef.current.play().catch(error => {
        console.error('Error auto-playing video:', error);
      });
    }
  }, [videoUrl]);

  return (
    <div className="relative w-full h-full max-w-3xl mx-auto">
      <div className="relative w-full h-full rounded-xl overflow-hidden shadow-2xl bg-black">
        <video
          ref={videoRef}
          src={videoUrl}
          className="h-full w-full object-cover"
          loop
          controls
          playsInline
          autoPlay
        />
        
        <div className="absolute inset-0 p-4 flex flex-col justify-between pointer-events-none">
          <div className="flex justify-between items-start">
            <div className="bg-black/50 backdrop-blur-sm rounded-full px-4 py-2 flex items-center gap-2 pointer-events-auto">
              <Heart className="w-4 h-4 text-red-500" fill="currentColor" />
              <span className="text-white text-sm">1.2k</span>
            </div>
            
            <div className="bg-black/50 backdrop-blur-sm rounded-full px-4 py-2 pointer-events-auto">
              <span className="text-white text-sm">🎁 Tip</span>
            </div>
          </div>
        </div>

        <VideoControls 
          videoId={videoId}
          onTip={onTip}
          tipAmount={tipAmount}
          setTipAmount={setTipAmount}
        />
      </div>
    </div>
  );
};

export default VideoPlayer;
